exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".DeleteButton__buttons__SmGNo {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    margin-top: 1rem;\n    -ms-flex-pack: center;\n        justify-content: center;\n}\n.DeleteButton__buttons__SmGNo button {\n    min-width: 6rem;\n    -ms-flex-positive: 0;\n        flex-grow: 0;\n    margin-bottom: 1rem !important;\n}\n\n.DeleteButton__errors__1Fgy7 {\n    color: #f34672;\n    margin-top: 1rem;\n}\n.DeleteButton__danger__3QXsK {\n    border-color: #f34672 !important;\n    color: #f34672\n}\n\n", ""]);

// exports
exports.locals = {
	"buttons": "DeleteButton__buttons__SmGNo",
	"errors": "DeleteButton__errors__1Fgy7",
	"danger": "DeleteButton__danger__3QXsK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/UI/Buttons/DeleteButton/DeleteButton.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/UI/Buttons/DeleteButton/DeleteButton.css
// module chunks = 0